import type { Conversation as SdkConversation } from "@twilio/conversations";
import type { ReduxConversation } from "../../../store/reducers/convoReducer";

export function mapSdkConversationToRedux(
  convo: SdkConversation
): ReduxConversation {
  return {
    sid: convo.sid,
    friendlyName: convo.friendlyName,
    dateUpdated: convo.dateUpdated,
    notificationLevel: convo.notificationLevel,
    lastReadMessageIndex: convo.lastReadMessageIndex,
    lastMessage: convo.lastMessage
      ? {
          index: convo.lastMessage.index,
          dateCreated: convo.lastMessage.dateCreated,
        }
      : undefined,
  };
}
